import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

@Injectable()
export class DashboardProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/dashboard';


  // Clubs

  clubStats(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/stats/club');
  }

  clubsAwaitingApproval(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/stats/club/awaiting');
  }

  approveClub(club_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + '/stats/club/approve', {club_id});
  } 

  // RH
  rhStats(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/stats/rh');
  }

    // Send an email invitation to the Users[]
    sendInvitation(emails): Observable<Response<any>>
    {
        return this.http.post<Response<any>>(`${this._url}/invite`, {emails});;
    }


    // List pending users
    listPendingUser(): Observable<Response<any>>
    {
        return this.http.get<Response<any>>(`${this._url}/invite/list`);
    }




}




// WEBPACK FOOTER //
// ./src/providers/dashboard/dashboard.ts